import { SelectOption } from '@/types/form.type.ts';

export enum CarNdsType {
    FullVat = 'full_vat',
    ProfitVat = 'profit_vat',
    NoVat = 'no_vat',
}

export function getCarNdsTypeLabel(type: CarNdsType): string {
    switch (type) {
        case CarNdsType.FullVat:
            return 'Полный НДС';
        case CarNdsType.ProfitVat:
            return 'НДС с прибыли';
        case CarNdsType.NoVat:
            return 'Нет НДС';
    }
}

export function getCarNdsTypeSelectOptions(): SelectOption[] {
    const options: SelectOption[] = [];

    Object.values(CarNdsType).forEach((type: CarNdsType) => {
        options.push({
            label: getCarNdsTypeLabel(type),
            value: type,
        });
    });

    return options;
}
